import {
  DomainAPI,
  Channel,
  Token,
  APIKey,
  Authorization,
  SecretApiKey,
  SecretApiKeyExpires,
  _pick,
} from "../utils/setting";
import { checkResponse } from "../utils/checkResponse";
import jwt from "jsonwebtoken";
import { Cookies } from "react-cookie";
const cookie = new Cookies();
const report = {
  state: {
    listBookings: [],
    totalBooking: 0,
    listOrders: [],
    totalOrder: 0,
  },
  reducers: {
    setState(state, payload) {
      this.state = { ...state, ...payload };
      return { ...this.state };
    },
  },
  effects: (dispatch) => ({
    getBookingReportSpa(payload, rootState) {
      const _this = this;
      let url =
        DomainAPI + Channel + "/api/secure/bookings/getListBookingReport";
      let key = jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, cookie.get(Token));
      return fetch(url, {
        method: "post",
        headers: myHeaders,
        body: JSON.stringify(_pick(payload, ["from", "to"])),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1) {
            _this.setState({
              listBookings: result.data.list,
              totalBooking: result.data.total,
            });
          }
          return result;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
    getListOrdersReportSpa(payload, rootState) {
      const _this = this;
      let url = DomainAPI + Channel + "/api/secure/orders/getListOrdersReport";
      let key = jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, cookie.get(Token));
      return fetch(url, {
        method: "post",
        headers: myHeaders,
        body: JSON.stringify(_pick(payload, ["from", "to"])),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1)
            _this.setState({
              listOrders: result.data.list,
              totalOrder: result.data.total,
            });
          return result;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
  }),
};
export default report;
